import { Type } from "@shared/ui/Type";
import { TimezoneOption } from "@platform/features/timezones/timezones.types";
import { AddToGoogleCalendarButton } from "@platform/features/calendarIntegration/components/AddToGoogleCalendarButton";
import { AddToICalButton } from "@platform/features/calendarIntegration/components/AddToICalButton";
import { Meeting } from "@platform/types/platform.types";

export type Props = {
  meeting?: Meeting;
  userTimezone?: TimezoneOption;
  onAddCalendarEvent: (
    meetingId: number,
    calendarType: "google" | "ical"
  ) => void;
};

export function ProgramCalendarEventItem({
  meeting,
  userTimezone,
  onAddCalendarEvent,
}: Props) {
  if (!meeting || !userTimezone) return null;

  const eventUrl = `https://pollinator.coop/video/join/${meeting.id}`;

  const eventDescription = `Join your peer circle meeting on Pollinator:\n${eventUrl}\n\nVisit https://pollinator.coop/dashboard to review the meeting materials and prepare.`;

  return (
    <div className="flex flex-col items-start  md:flex-row md:items-center justify-between py-4 gap-4">
      <div className="flex flex-col gap-1 flex-1">
        <Type variant="h6">
          {meeting.title}
          {meeting.isTimeShifted && (
            <span className="text-brand-700 ml-0.5">*</span>
          )}
        </Type>
        <Type variant="caption">{meeting.localStartTime}</Type>
        {meeting.isTimeShifted && (
          <Type variant="caption" className="text-brand-700 italic">
            * Note time change for this meeting.
          </Type>
        )}
        {meeting.userRole && (
          <Type variant="caption">
            Your role:{" "}
            <span className="font-medium text-brand-700">
              {meeting.userRole.name}
            </span>
          </Type>
        )}
      </div>
      <div className="flex flex-row gap-2 flex-shrink-0">
        <AddToICalButton
          meeting={meeting}
          eventTitle={`Pollinator | ${meeting.title}`}
          eventDescription={eventDescription}
          eventUrl={eventUrl}
          onAddCalendarEvent={onAddCalendarEvent}
        />
        <AddToGoogleCalendarButton
          meeting={meeting}
          eventTitle={`Pollinator | ${meeting.title}`}
          eventDescription={eventDescription}
          eventUrl={eventUrl}
          onAddCalendarEvent={onAddCalendarEvent}
        />
      </div>
    </div>
  );
}

export default ProgramCalendarEventItem;
